import { loadRegionsJSONArray } from "../API";


export function getToken() {
  return localStorage.getItem("access_token_nasi_paipon");
}
export function getUserType() {
  return localStorage.getItem("user_type_nasi_paipon");
}
export function setToken(t) {
  if (t !== null) localStorage.setItem("access_token_nasi_paipon",t);

}

export function setUserType(t) {
  if (t !== null) localStorage.setItem("user_type_nasi_paipon",t);

}

export function clearStorage(){
    localStorage.clear();
}


var regions = null;

export function getRegions(onComplete){
  if(regions!=null){
    onComplete(null,regions);
    return;
  }

  loadRegionsJSONArray((err,res)=>{
    if(err) onComplete(err,null);
    else {
      regions = res;
      onComplete(null,regions);
    }
  })
  
}